const NavigationArrowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_4562_1439)">
        <mask id="mask0_4562_1439" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24" mask-type="alpha">
          <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4562_1439)">
          <path
            d="M10.3069 12.0053L15.6825 17.2462C15.8942 17.4525 15.9965 17.6932 15.9894 17.9683C15.9824 18.2434 15.873 18.4842 15.6614 18.6905C15.4497 18.8968 15.2028 19 14.9206 19C14.6384 19 14.3915 18.8968 14.1799 18.6905L8.50794 13.1814C8.33862 13.0164 8.21164 12.8307 8.12698 12.6243C8.04233 12.418 8 12.2117 8 12.0053C8 11.799 8.04233 11.5927 8.12698 11.3863C8.21164 11.18 8.33862 10.9943 8.50794 10.8292L14.1799 5.29952C14.3915 5.09318 14.642 4.99346 14.9312 5.00033C15.2205 5.00721 15.4709 5.11382 15.6825 5.32015C15.8942 5.52648 16 5.7672 16 6.04231C16 6.31742 15.8942 6.55814 15.6825 6.76448L10.3069 12.0053Z"
            fill="#5D6977"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4562_1439">
          <rect width="24" height="24" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NavigationArrowSvg;
